import { type Address } from "@modules/address/addressTypes"

export const EmptyAddress: Address = {
  address: "",
  city: "",
  postalCode: "",
  country: "",
  additionalInformation: null,
}
